import { useDictionary, useItem } from "@adamlip/okeoke.client"
import OrderItemModalV3 from "components/Modals/OrderItemModalV3"
import { UserContext } from "contexts/UserContext"
import { useContext, useEffect, useRef, useState } from "react"
import { toast } from "react-hot-toast"
import SwipeableItem from "./ItemLayouts/SwipeableItem"
import DefaultItem from "./ItemLayouts/DefaultItem"
import SimonStyleItem from "./ItemLayouts/SimonStyleItem"
import BorderedItem from "./ItemLayouts/BorderedItem"
import useBasket from "hooks/useBasket"
import { AppParamsContext } from "contexts/AppParamsContext"

export default function Item({
  banned,
  assembledItem,
  readOnly,
  menuItemParams,
}) {
  const { appParams } = useContext(AppParamsContext)
  const { userLoggedIn } = useContext(UserContext)
  const { getValue } = useDictionary()
  const { addItem } = useBasket()

  const { assembledItem: hookAssembledItem, setCount } = useItem(
    assembledItem.uuid,
    assembledItem.selectedSizeUUID
  )

  const [itemModalOpen, setItemModalOpen] = useState(false)
  const defaultCountDone = useRef(null)

  const addItemToBasket = (count) => {
    setCount(count)
    if (userLoggedIn) {
      if (menuItemParams && typeof menuItemParams?.onAdd === "function") {
        if (hookAssembledItem.count > 0 && hookAssembledItem.valid) {
          menuItemParams?.onAdd(hookAssembledItem)
        } else {
          setItemModalOpen(true)
        }
      } else {
        if (hookAssembledItem.count > 0 && hookAssembledItem.valid) {
          let response = addItem(hookAssembledItem)
          if (response != null) {
            toast.success(getValue("app_v2_toast_itemAdded"))
          } else {
            console.log(response)
            toast.error(getValue("app_v2_toast_itemFailed"))
          }
        } else {
          toast.error(getValue("app_v2_toast_itemFailed"))
        }
      }
    } else {
      toast.error(getValue("app_v2_toast_needLogin"))
    }
  }

  useEffect(() => {
    if (
      hookAssembledItem != null &&
      !defaultCountDone.current &&
      menuItemParams?.defaultCount > 0
    ) {
      addItemToBasket(menuItemParams?.defaultCount)
      defaultCountDone.current = true
    }
    //eslint-disable-next-line
  }, [hookAssembledItem, menuItemParams])

  return (
    <>
      <OrderItemModalV3
        isOpen={itemModalOpen}
        setIsOpen={setItemModalOpen}
        itemUUID={assembledItem.uuid}
        readOnly={readOnly}
        menuItemParams={menuItemParams}
        sizeUUID={menuItemParams?.selectedSizeUUID}
      />
      {appParams?.items?.layoutType == null ||
        (appParams?.items?.layoutType === "1" && (
          <DefaultItem
            assembledItem={assembledItem}
            banned={banned}
            setItemModalOpen={setItemModalOpen}
            readOnly={readOnly}
            menuItemParams={menuItemParams}
          />
        ))}
      {appParams?.items?.layoutType === "2" && (
        <SwipeableItem
          assembledItem={assembledItem}
          banned={banned}
          setItemModalOpen={setItemModalOpen}
          addItemToBasket={addItemToBasket}
          readOnly={readOnly}
          menuItemParams={menuItemParams}
        />
      )}
      {appParams?.items?.layoutType === "3" && (
        <SimonStyleItem
          assembledItem={assembledItem}
          banned={banned}
          setItemModalOpen={setItemModalOpen}
          readOnly={readOnly}
          menuItemParams={menuItemParams}
        />
      )}
      {appParams?.items?.layoutType === "4" && (
        <BorderedItem
          assembledItem={assembledItem}
          banned={banned}
          setItemModalOpen={setItemModalOpen}
          readOnly={readOnly}
          menuItemParams={menuItemParams}
        />
      )}
    </>
  )
}
